var _rect, _rect2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalculeterIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 14.6165,
    height: 18.5,
    rx: 1.25,
    stroke: "#2E77D0",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.34229,
    y: 4.53638,
    width: 7.43204,
    height: 3.64563,
    rx: 1.25,
    stroke: "#2E77D0",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.51462,
    cy: 11.6992,
    r: 0.92233,
    fill: "#2E77D0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00973,
    cy: 11.6992,
    r: 0.92233,
    fill: "#2E77D0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.602,
    cy: 11.6992,
    r: 0.92233,
    fill: "#2E77D0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.51462,
    cy: 15.1941,
    r: 0.92233,
    fill: "#2E77D0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00973,
    cy: 15.1941,
    r: 0.92233,
    fill: "#2E77D0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.602,
    cy: 15.1941,
    r: 0.92233,
    fill: "#2E77D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculeterIcon);
export default __webpack_public_path__ + "static/media/calculeterIcon.e566cda31575ae2c588d40d911f30dab.svg";
export { ForwardRef as ReactComponent };